/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.userAmazonCatalogue.internal

import features.userAmazonCatalogue.models.UserRewardsModel
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.domain.AsyncUseCase
import features.userAmazonCatalogue.internal.UserAmazonCatalogueUseCase.Params

internal class UserAmazonCatalogueUseCase : AsyncUseCase<UserRewardsModel, Params>() {

    internal class Params(
       val overrideHeaders : Map<String, String>? = null,
        val pageNumber: Int,
        val perPage: Int,
        val keywords: String?,
        val filters: String?
    )

    private val userAmazonCatalogueService: UserAmazonCatalogueService = UserAmazonCatalogueServiceImpl()

    override suspend fun run(params: Params): Result<UserRewardsModel> {
        return userAmazonCatalogueService.getUserAmazonCatalogue(
            overrideHeaders = params.overrideHeaders,
            pageNumber = params.pageNumber,
            perPage = params.perPage,
            keywords = params.keywords,
            filters = params.filters
        )
    }
}
